import { render, staticRenderFns } from "./studentInfo.pug?vue&type=template&id=6319f2be&scoped=true&lang=pug&"
import script from "./studentInfo.ts?vue&type=script&lang=ts&"
export * from "./studentInfo.ts?vue&type=script&lang=ts&"
import style0 from "./studentInfo.styl?vue&type=style&index=0&id=6319f2be&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6319f2be",
  null
  
)

export default component.exports